import * as React from 'react';

function SvgArrow(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14" {...props}>
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={2}
        d="M1.667 7 7 1.667M7 12.333 1.667 7M2.334 7H13"
      />
    </svg>
  );
}
export default SvgArrow;
